import { render } from "./ProjectsActiveList.vue?vue&type=template&id=6e492846"
import script from "./ProjectsActiveList.vue?vue&type=script&lang=js"
export * from "./ProjectsActiveList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__